import React from 'react';
import UserAccount from '../UserAccount';

function SignUp() {
  return (
    <div className="SignUp">
      <UserAccount />
    </div>
  );
}

export default SignUp;
